import axios, { AxiosPromise } from 'axios';
import {
  IGetSpeaking,
  IGetSpeakingList,
  IGetSpeakingListParams,
  IGetSpeakingPaper,
  IGetSpeakingQuery,
  IGetSpeakingRubric,
  IGetSpeakingRubricCheck,
  IGetSpeakingRubricItem,
  IGetSpeakingRubricList,
  IGetSpeakingTestPaper,
  IPostSpeakingRubricReq,
  ISpeakingBody,
  ISpeakingResultBody,
  ISpeakingRubricItemBody,
  ISpeakingRubricItemModBody,
} from '../models/newSpeaking.model';

const uri = '/mgmt/speaking';

export const getSpeakingRubricList = (): AxiosPromise<IGetSpeakingRubricList> => {
  return axios.get(`${uri}/rubric`);
};

export const postSpeakingRubric = (req: IPostSpeakingRubricReq): AxiosPromise<IGetSpeakingRubric> => axios.post(`${uri}/rubric`, req);

export const putSpeakingRubric = (rubricNo: number | string, req: IPostSpeakingRubricReq): AxiosPromise<IGetSpeakingRubric> =>
  axios.put(`${uri}/rubric/${rubricNo}`, req);

export const getSpeakingRubric = (
  rubricNo: number | string,
): AxiosPromise<IGetSpeakingRubric> => axios.get(`${uri}/rubric/${rubricNo}`);

export const getSpeakingRubricCheck = (
  rubricNo: number | string,
): AxiosPromise<IGetSpeakingRubricCheck> =>
  axios.get(`${uri}/rubric/${rubricNo}/check`);

export const getSpeakingRubricItem = (
  evaluationNo: number | string,
): AxiosPromise<IGetSpeakingRubricItem> =>
  axios.get(`${uri}/rubric/item/${evaluationNo}`);

export const postSpeakingRubricItem = (
  body: ISpeakingRubricItemBody,
): AxiosPromise<IGetSpeakingRubricItem> =>
  axios.post(`${uri}/rubric/item`, body);

export const getSpeakingRubricItemScale = (
  evaluationNo: number,
): AxiosPromise<IGetSpeakingRubricItem> =>
  axios.get(`/mgmt/speaking/rubric/item/${evaluationNo}`);

export const putSpeakingRubricItem = (
  evaluationNo: number,
  body: ISpeakingRubricItemModBody,
): AxiosPromise<IGetSpeakingRubricItem> =>
  axios.put(`/mgmt/speaking/rubric/item/${evaluationNo}`, body);

export const getSpeakingList = (params?: IGetSpeakingListParams): AxiosPromise<IGetSpeakingList> => {
  return axios.get(uri, { params });
};

export const getSpeaking = (
  speakingExamCode: string | number,
): AxiosPromise<IGetSpeaking> => axios.get(`${uri}/${speakingExamCode}`);

export const postSpeaking = (body: ISpeakingBody): AxiosPromise<IGetSpeaking> =>
axios.post(uri, body);

export const putSpeaking = (
  speakingExamCode: string | number,
  body: ISpeakingBody,
): AxiosPromise<IGetSpeaking> => axios.put(`${uri}/${speakingExamCode}`, body);

export const postSpeakingPaper = (
  form: FormData,
): AxiosPromise<IGetSpeakingPaper> => axios.post(`${uri}/paper`, form);

export const getSpeakingPaper = (
  params: IGetSpeakingQuery,
): AxiosPromise<IGetSpeakingPaper> =>
  axios.get(`${uri}/paper/detail`, { params });

export const putSpeakingPaper = (
  form: FormData,
): AxiosPromise<IGetSpeakingPaper> => axios.put(`${uri}/paper`, form);

export const postSpeakingResult = (body: ISpeakingResultBody): AxiosPromise =>
  axios.post(`${uri}/result`, body);

export const getSpeakingTestPaper = (
  params: IGetSpeakingQuery,
): AxiosPromise<IGetSpeakingTestPaper> =>
  axios.get(`${uri}/test-paper`, { params });
